import React from 'react';
import { Link } from 'anf-core-react';

export default function FindAStoreButton({ inline, ctaLabel, setModalState }) {
  let classes = 'find-a-store-button-block';

  const setFindAStoreModalOpen = () => {
    setModalState(true);
  };

  if (inline) {
    classes = 'find-a-store-button-inline';
  }

  return (
    <Link onClick={setFindAStoreModalOpen} classList={classes}>
      {ctaLabel}
    </Link>
  );
}
